import React from "react";
import { useAuth } from "@/context/AuthContext";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cleaning-crm-pro/artifacts/fvdkcx4l_image.png";

export default function Logo({ size = 48, showText = false, className = "", dark = false }) {
  const { settings } = useAuth();
  const url = settings?.logo_url || LOGO_URL;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <img
        src={url}
        alt="Magic Touch Professional Cleaning"
        style={{ width: size, height: size }}
        className="rounded-full object-cover ring-2 ring-[#D4AF37]/70 shadow-md"
      />
      {showText && (
        <div className="leading-tight">
          <div className={`font-display font-bold text-lg tracking-tight ${dark ? "text-white" : "text-[#5A189A]"}`}>
            Magic Touch
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37] font-semibold">
            Professional Cleaning
          </div>
        </div>
      )}
    </div>
  );
}
